// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DemoSystem_wrapper__1RUef"};